export const ACTIONS = {
  CREATE_POLICY: "Create Policy",
  UPDATE_POLICY: "Update Policy",
  RETIRE_POLICY: "Retire Policy",
  POLICY_DRAFTED: "Policy Drafted",
  CAB_APPROVED: "CAB Approved",
  POST_CAB_UPDATE: "Post-CAB Update",
};
export const MESSAGES = {
  CAB_VALIDATION_ERR_MSG: "Coding & Translation must be complete for ",
};
